import React from "react";
import Card from "../../../components/page/Card";
import CommonButton from "../../../components/buttons/CommonButton";
import PropTypes from "prop-types";

const ECnpjCard = ({ togComprarCertificadoModal }) => {
  return (
    <Card margin={0}>
      <div className="d-flex">
        <div className="flex-grow-1">
          <h5>e-CNPJ A1</h5>
          <p className="text-muted">
            Certificado digital para a pessoa jurídica
          </p>
        </div>
        <div className="flex-shrink-0 ms-3">
          <i className="fas fa-building h1 text-orange"></i>
        </div>
      </div>
      <div className="py-4">
        <p className="text-muted">de R$ 200,00 por</p>
        <h2>
          <sup>
            <small>R$</small>
          </sup>{" "}
          180,00
        </h2>
      </div>
      <div className="text-center plan-btn d-flex justify-content-center">
        <CommonButton
          onClick={togComprarCertificadoModal}
          color="orange"
          small
          style={{ zIndex: "1" }}
        >
          Compre agora!
        </CommonButton>
      </div>

      <div className="plan-features mt-5">
        <p>
          <i className="bx bxs-check-circle mr-2 text-orange"></i> Emissão por
          videoconferência
        </p>
        <p>
          <i className="bx bxs-check-circle mr-2 text-orange"></i> Válido por 12
          meses
        </p>
        <p>
          <i className="bx bxs-check-circle mr-2 text-orange"></i> Assinatura
          digital com validade jurídica
        </p>
        <p>
          <i className="bx bxs-check-circle mr-2 text-orange"></i> Emissão de
          NFS-e
        </p>
      </div>
    </Card>
  );
};

const ECpfCard = ({ togComprarCertificadoModal }) => {
  return (
    <Card margin={0}>
      <div className="d-flex">
        <div className="flex-grow-1">
          <h5>e-CPF A1</h5>
          <p className="text-muted">Certificado digital para a pessoa física</p>
        </div>
        <div className="flex-shrink-0 ms-3">
          <i className="fas fa-user-shield h1 text-orange"></i>
        </div>
      </div>
      <div className="py-4">
        <p className="text-muted">de R$ 130,00 por</p>
        <h2>
          <sup>
            <small>R$</small>
          </sup>{" "}
          110,00
        </h2>
      </div>
      <div className="text-center plan-btn d-flex justify-content-center">
        <CommonButton
          onClick={togComprarCertificadoModal}
          color="orange"
          small
          style={{ zIndex: "1" }}
        >
          Compre agora!
        </CommonButton>
      </div>

      <div className="plan-features mt-5">
        <p>
          <i className="bx bxs-check-circle mr-2 text-orange"></i> Emissão por
          videoconferência
        </p>
        <p>
          <i className="bx bxs-check-circle mr-2 text-orange"></i> Válido por 12
          meses
        </p>
        <p>
          <i className="bx bxs-check-circle mr-2 text-orange"></i> Assinatura
          digital com validade jurídica
        </p>
        <p>
          <i className="bx bxs-check-circle mr-2 text-orange"></i> Serviços
          eletrônicos de cartório
        </p>
      </div>
    </Card>
  );
};

function NovoCertificadoCards({ togComprarCertificadoModal }) {
  return (
    <>
      <div className="row mt-5 mb-5">
        <div className="col-md-12">
          <div className="row text-center">
            <div className="col-md-12">
              <h4 className="font-size-20">
                Precisa de um novo certificado digital?
              </h4>
            </div>
          </div>
          <div className="row text-center">
            <div className="col-md-12">
              <p className="font-size-14 text-muted">
                A Orangiuz tem parceria com a Soluti, a líder em emissões de
                certificados digitais, para oferecer
                <br className="d-md-block" style={{ display: "none" }} />
                para você a melhor solução de certificação digital do mercado.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-xl-4 col-md-6 plan-box">
          <ECpfCard togComprarCertificadoModal={togComprarCertificadoModal} />
        </div>
        <div className="col-xl-4 col-md-6 plan-box">
          <ECnpjCard togComprarCertificadoModal={togComprarCertificadoModal} />
        </div>
      </div>
    </>
  );
}

ECnpjCard.propTypes = {
  togComprarCertificadoModal: PropTypes.func.isRequired,
};

ECpfCard.propTypes = {
  togComprarCertificadoModal: PropTypes.func.isRequired,
};

NovoCertificadoCards.propTypes = {
  togComprarCertificadoModal: PropTypes.func.isRequired,
};

export default NovoCertificadoCards;
